// src/pages/PatientsOverview/PatientsSelectors.js
export const selectInsuranceList = (state) => state.patients.insuranceList || [];
export const selectPatientList = (state) => state.patients.patientList || [];
export const selectInsuranceLookup = (state) => state.patients.insuranceLookup || [];

export const selectSelectedInsurance = (state) => state.patients.selectedInsurance;
export const selectSelectedPatient = (state) => state.patients.selectedPatient;

export const selectIsInsuranceModalOpen = (state) => state.patients.isInsuranceModalOpen;
export const selectIsPatientModalOpen = (state) => state.patients.isPatientModalOpen;
export const selectIsEditInsurance = (state) => state.patients.isEditInsurance;
export const selectIsEditPatient = (state) => state.patients.isEditPatient;
